import {FC, useCallback, useEffect, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import WSButton from '../../../../../../_metronic/helpers/components/WSButton/WSButton'
import {List} from '../../../../../../services/cellcast.v2.types'
import {useWriteList} from '../useWriteListHook'

export type WriteListModalProps = {
  show: boolean
  list?: List
  handleClose: () => void
  callbackFn: () => void
}

const WriteModal: FC<WriteListModalProps> = (props) => {
  const {list, show, handleClose, callbackFn} = props
  const [name, setName] = useState('')

  const {createHandler, createLoading, updateHandler, updateLoading} = useWriteList()

  useEffect(() => {
    if (list && list.name && list.name.length > 0) {
      setName(list.name)
    }

    if (show === false) {
      setName('')
    }
  }, [list, show])

  const handleSubmit = useCallback(() => {
    if (name === '') {
      return
    }

    if (list && list._id && list._id.length > 0) {
      updateHandler({_id: list._id, name: name}, function () {
        if (callbackFn) {
          callbackFn()
        }
      })
    } else {
      createHandler({name}, function () {
        if (callbackFn) {
          callbackFn()
        }
      })
    }
  }, [show, name, list])

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>
            {list && list._id && list._id.length > 0 ? 'Update' : 'Create'} New List
          </h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body py-lg-5 px-lg-5 border-bottom'>
          <div className='mb-10 container'>
            <label className='form-label required'>List Name</label>
            <input
              onChange={(e: any) => setName(e.target.value)}
              type='text'
              className='form-control form-control-solid bg-light border-0'
              placeholder='Your List Name'
              value={name}
            />
          </div>

          <div className='container d-flex align-items-end justify-content-end mt-6 mb-5'>
            <WSButton
              type='submit'
              className='btn btn-lg btn-light-primary me-5 fw-500'
              onClick={() => {
                handleClose()
              }}
            >
              <span className='indicator-label'>Cancel</span>
            </WSButton>
            <WSButton
              disabled={name?.trim() === '' || createLoading || updateLoading}
              type='submit'
              className='btn btn-lg btn-primary fw-500'
              onClick={() => handleSubmit()}
            >
              <span className='indicator-label'>
                {createLoading || updateLoading ? <Spinner animation='grow' size='sm' /> : 'Submit'}
              </span>
            </WSButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WriteModal
